import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

import type { Instance } from "@wasmer/sdk";
// @ts-ignore
import WasmModule from "@wasmer/sdk/wasm?url";

function connectStreams(instance: Instance) {
	instance.stdout.pipeTo(
		new WritableStream({
			write: (chunk) => {
				process.stdout.write(chunk);
			},
		}),
	);
	instance.stderr.pipeTo(
		new WritableStream({
			write: (chunk) => {
				process.stderr.write(chunk);
			},
		}),
	);
}

import "react-reflex/styles.css";
import { Button } from "@acme/ui/button";

export const TestPage = () => {
	return (
		<div className="w-full h-[100vh] m-0 bg-black">
			<Button
				onClick={async () => {
					// Note: We dynamically import the Wasmer SDK to make sure the bundler puts
					// it in its own chunk. This works around an issue where just importing
					// xterm.js runs top-level code which accesses the DOM, and if it's in the
					// same chunk as @wasmer/sdk, each Web Worker will try to run this code and
					// crash.
					// See https://github.com/wasmerio/wasmer-js/issues/373
					const { Wasmer, init, Directory } = await import("@wasmer/sdk");

					await init({ module: WasmModule });
					const home = new Directory();
					await home.writeFile(
						"test.js",
						`
const res = await fetch("https://example.com");
const body = await res.text();
console.log("body", body);
`,
					);

					console.log("Starting");
					// const pkg = await Wasmer.fromRegistry("wasmer/winterjs");
					const pkg = await Wasmer.fromRegistry("curl/curl");

					const instance = await pkg.entrypoint!.run({
						// args: ["exec", "test.js"],
						args: ["--", "localhost:5173"],
						uses: ["wasmer/neatvi"],
						mount: { "/home": home },
						cwd: "/home",
						env: {
							HTTP_PROXY: "http://localhost:8080",
						},
					});
					console.log("started instance");
					const { code, stdout, stderr } = await instance.wait();
					if (stderr) {
						console.error("err:", stderr);
					}

					console.log(`exited with ${code}: ${stdout}`);
					// connectStreams(instance);
				}}
			>
				Run
			</Button>
		</div>
	);
};
